import { render } from "./OrganizerListItem.vue?vue&type=template&id=2db4b82d&scoped=true"
import script from "./OrganizerListItem.vue?vue&type=script&lang=js"
export * from "./OrganizerListItem.vue?vue&type=script&lang=js"

import "./OrganizerListItem.vue?vue&type=style&index=0&id=2db4b82d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db4b82d"]])

export default __exports__